import { startOfDay } from 'date-fns';
import { fromZonedTime, toZonedTime } from 'date-fns-tz';
/**
 * Returns the UTC `Date` that represents 00:00 on the calendar day of `date` as observed
 * in `timezone`. Accepts both IANA names (e.g. `'America/New_York'`) and fixed UTC offsets
 * (e.g. `'-05:00'`, `'+09:00'`), since `date-fns-tz` supports both forms.
 */
export const startOfDayInTimezone = (date, timezone) => {
    const zonedDate = toZonedTime(date, timezone);
    const startOfDayZoned = startOfDay(zonedDate);
    return fromZonedTime(startOfDayZoned, timezone);
};
//# sourceMappingURL=start-of-day-in-timezone.js.map